import { Identity } from "../types";
// import jwt_decode from "jwt-decode";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const initialState = {
  loggedIn: false,
  userId: -1,
  accessCode: 0,
  identity: Identity.None,
  expires: 0
};

export const userReducer = (state, action) => {
  switch (action.type) {
    case LOGIN:
      localStorage.setItem("authInfo", action.token);
      return {
        ...state,
        // eslint-disable-next-line no-undef
        // ...jwt_decode(action.token),
        loggedIn: true,
        userId: 1,
        identity: Identity.ROOT,
        // accessCode: 0b01111111,
        accessCode: 0b011111111,
        expires: 99999999999
      };
    case LOGOUT:
      localStorage.removeItem("authInfo");
      return initialState;
    default:
      return state;
  }
};
